import { selectSession } from 'core/selectors/product/session';
import { ISessionReducer } from 'core/slices/session';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Role } from 'types/domain/role';

export function useIsAdmin() {
  const session: ISessionReducer = useSelector(selectSession);
  return [Role.AUTHOR, Role.ADMIN, Role.SUPER_ADMIN].includes(session.role) && session.jwt;
}

export function useIsSuperAdmin() {
  const session: ISessionReducer = useSelector(selectSession);
  return [Role.SUPER_ADMIN].includes(session.role) && session.jwt;
}
